module.exports = __webpack_public_path__ + "media/packs/images/flags/TH-9ef60baeae7435e807cb40b8adaca656.svg";